import React from 'react';
import { createRoot } from 'react-dom/client';
import ChapterEventList from './components/forum/ChapterEventList/ChapterEventList';
import PastEventList from './components/forum/ChapterEventList/PastEventList';
import FlipCountdown from './components/forum/ChapterEventList/FlipCountdown';
import EventProgram from './components/forum/EventProgram/EventProgram';
import WorldMap, { TOPO_DETAILED } from './components/forum/EventProgram/Hero/WorldMap';
import SpeakerEvents from './components/speaker/SpeakerEvents';
import EventArticleManager from './components/forum/EventArticle/EventArticleManager';
import EventArticleReader from './components/forum/EventArticle/EventArticleReader';

// Chapter — Upcoming Events
const chapterUpcoming = document.getElementById('chapter-upcoming-events');
if (chapterUpcoming) {
    const events   = JSON.parse(chapterUpcoming.dataset.events);
    const featured = JSON.parse(chapterUpcoming.dataset.featured || 'null');
    createRoot(chapterUpcoming).render(<ChapterEventList featured={featured} events={events} />);
}

// Chapter — Past Events
const chapterPast = document.getElementById('chapter-past-events');
if (chapterPast) {
    const events = JSON.parse(chapterPast.dataset.events);
    createRoot(chapterPast).render(<PastEventList events={events} />);
}

// Speaker page — events (upcoming + past): shared EventCard + modal
const speakerEvents = document.getElementById('speaker-events');
if (speakerEvents) {
    const upcoming = JSON.parse(speakerEvents.dataset.upcoming || '[]');
    const past = JSON.parse(speakerEvents.dataset.past || '[]');
    createRoot(speakerEvents).render(<SpeakerEvents upcoming={upcoming} past={past} />);
}

// Event Program (forum/sessions) — boots from server-rendered data-program
const programContainer = document.getElementById('event-program');
if (programContainer) {
    const program = JSON.parse(programContainer.dataset.program || '{}');
    createRoot(programContainer).render(<EventProgram program={program} />);
}

// Display-only map. focus=true zooms onto the region; focus=false is the whole-network
// world view (GLOBAL chapter, events page). Used by the chapter hero (#chapter-hero-map),
// each forum-index card ([data-chapter-map]), and the Speaking hero — which passes
// countries instead of chapters under the same key.
const mountChapterMap = (el, raw, opts = {}) => {
    const cfg = JSON.parse(raw || 'null');
    if (!cfg || !cfg.chapters) return;
    // Highlight the chapter(s) at full strength on every map — region focus and
    // whole-network alike — so cards and heroes read consistently.
    createRoot(el).render(
        <WorldMap
            chapters={cfg.chapters}
            activeChapters={cfg.chapters.map((c) => c.slug)}
            focus={cfg.focus}
            {...opts}
        />
    );
};

const chapterHeroMap = document.getElementById('chapter-hero-map');
if (chapterHeroMap) mountChapterMap(chapterHeroMap, chapterHeroMap.dataset.map); // chapter page hero

// Speaking hero — countries that have hosted a public engagement. The only map on the
// detailed geometry: host organizations sit in city-states the coarse set omits
// (Singapore, Hong Kong), which would otherwise drop out of the map without a trace.
// Names move to the tooltip here: one region per country is far more than the labels
// can sit beside each other for. pinOnlyStates: a state-tagged event still fills its
// whole country (a state pin is a location within a country's footprint, not instead
// of it) — states only place pins, never paint over the country.
const engagementHeroMap = document.getElementById('engagement-hero-map');
if (engagementHeroMap) {
    mountChapterMap(engagementHeroMap, engagementHeroMap.dataset.map, {
        topoUrl: TOPO_DETAILED,
        namesOnHover: true,
        pinOnlyStates: true,
    });
}

// forum index — one map per chapter card
document.querySelectorAll('[data-chapter-map]').forEach((el) => mountChapterMap(el, el.dataset.chapterMap));

// Event countdown
const eventCountdown = document.getElementById('event-countdown');
if (eventCountdown) {
    createRoot(eventCountdown).render(
        <FlipCountdown targetUtc={eventCountdown.dataset.startUtc} onEnd={() => location.reload()} />
    );
}

// Event article — managers boot the full manager; readers get the read/teaser
// view (the server decides the mode and what the payload may contain)
const eventArticle = document.getElementById('event-article-manager');
if (eventArticle) {
    const payload = JSON.parse(eventArticle.dataset.payload || '{}');
    createRoot(eventArticle).render(payload.mode === 'manage'
        ? <EventArticleManager payload={payload} />
        : <EventArticleReader payload={payload} />);
}